import React from 'react';

const Pregnant = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="28"
    viewBox="0 0 22 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2123_5795)">
      <path
        d="M10.8249 0.0101918C12.9967 -0.142037 14.7778 1.51726 14.9351 3.55206C15.1431 6.24651 12.8749 8.35742 10.1551 7.7891C8.39939 7.42375 6.91769 5.84564 7.08007 3.57743C7.15618 2.48138 7.64332 1.68471 8.24208 1.09609C8.8307 0.522696 9.68826 0.0863064 10.8249 0.0101918Z"
        fill="white"
      />
      <path
        d="M15.1686 13.0865V16.395H6.84672V13.1373C6.77061 13.0764 6.66912 13.259 6.58793 13.3453C5.57307 14.3754 4.52269 15.3852 3.46216 16.4457C2.96995 16.9379 2.35596 17.8462 1.23962 17.4809C0.498767 17.2424 -0.120298 16.1717 0.412504 15.2329C0.58503 14.9285 0.960529 14.6342 1.23962 14.3551C2.66549 12.9292 4.03048 11.5642 5.47666 10.118C6.02468 9.57002 6.62345 8.81395 7.23237 8.4892C7.344 8.43338 7.63831 8.32682 7.80069 8.30652C8.7851 8.21011 9.90145 8.30652 11.033 8.30652H12.6619C13.4636 8.30652 14.1892 8.22533 14.6764 8.46382C15.2041 8.71754 15.5694 9.16915 15.9957 9.5751C17.3099 10.8335 18.68 12.2594 19.9993 13.5838C20.522 14.1064 21.2374 14.6595 21.5774 15.2126C22.2777 16.3493 21.1715 18.0441 19.6898 17.4606C19.2686 17.2931 18.8018 16.7299 18.5024 16.4254C17.3911 15.2938 16.2951 14.2029 15.1686 13.0916"
        fill="white"
      />
      <path
        d="M9.89634 21.1243C9.06415 21.8195 8.1863 22.464 7.20696 23.012C7.57231 24.1385 8.29286 25.5694 8.19137 27.0156C8.13555 27.7565 7.59768 28.2436 6.82131 27.8681C6.65893 27.792 6.52192 27.6803 6.40522 27.5839C5.75063 27.041 5.2432 26.1936 4.77636 25.2853C4.5531 24.8489 4.36535 24.3973 4.18267 23.9152C3.83254 23.0018 3.72598 21.9768 4.1573 21.0736C4.76114 19.8101 5.84197 18.7039 6.74012 17.7905C7.8108 18.8815 8.83581 20.0181 9.89126 21.1243"
        fill="white"
      />
      <path
        d="M14.8032 23.0374C13.8543 22.4589 12.9713 21.8195 12.1138 21.1497C13.1439 20.008 14.1993 18.8967 15.2649 17.7905C15.2852 17.7905 15.2903 17.8159 15.3157 17.8159C16.1935 18.7851 17.2033 19.7188 17.8477 21.0736C18.5581 22.5654 17.8122 24.1182 17.1779 25.336C16.706 26.2342 16.2443 27.0156 15.6556 27.5332C15.0213 28.0914 13.9151 28.2537 13.8187 27.041C13.7071 25.61 14.4479 24.037 14.8032 23.0374Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2123_5795">
        <rect
          width="21.581"
          height="28"
          fill="white"
          transform="translate(0.209473)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Pregnant;
